import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js'
import './css/main.css'
import './Header.css';
import logo_h from './vbcontrol_horizontal_dark.svg';
import React from 'react';
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Header() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const currentLanguage = (i18n.resolvedLanguage || i18n.language || 'nl').substring(0, 2);

  const pathName = (location.pathname).substring(1);
  const active = pathName || 'home';

  const changeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <span id="header">
      <div class="top"></div>
      <nav class="navbar sticky-top navbar-expand-md bg-dark border-body vb-navbar" data-bs-theme="dark">
        <div class="container-sm">
          <Link to="/home" className="navbar-brand">
            <img src={logo_h} alt="VB Control" width="175"/>
          </Link>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
              <li class="nav-item">
                <Link id="home" 
                      className={active === "home" ? "nav-link active active-link" : "nav-link"} 
                      to="/home">
                      {t('nav.home')}
                </Link>
              </li>
              <li class="nav-item">
                <Link id="contact" 
                      className={active === "contact" ? "nav-link active active-link" : "nav-link"} 
                      to="/contact">
                      {t('nav.contact')}
                </Link>
              </li>
              <li class="nav-item">
                <Link id="about" 
                      className={active === "about" ? "nav-link active active-link" : "nav-link"} 
                      to="/about">
                      {t('nav.about')}
                </Link>
              </li>
            </ul>
            <div class="vb-language-switch" role="group" aria-label={t('nav.language')}>
              <button
                type="button"
                class={`vb-language-button ${currentLanguage === 'nl' ? 'vb-language-button--active' : ''}`}
                onClick={() => changeLanguage('nl')}
              >
                NL
              </button>
              <button
                type="button"
                class={`vb-language-button ${currentLanguage === 'en' ? 'vb-language-button--active' : ''}`}
                onClick={() => changeLanguage('en')}
              >
                EN
              </button>
            </div>
          </div>
        </div>
      </nav>
    </span>

  );
}

export default Header;
